import { createRouter, createWebHistory } from "vue-router";
import { ReviseMeta } from "@/util/meta";
import { deviceType } from "@/util/base";

function createAdRoutes(platforms) {
  return platforms.flatMap(({ prefix, versions, componentMap }) =>
    versions.map((version) => ({
      path: `${prefix}-${version}`,
      name: `${prefix}-${version}`,
      component: () =>
        import(`./views/down/${componentMap[version] || version}.vue`),
    }))
  );
}

const adRoutesVersions = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "B2",
  "C2",
  "D2",
];

// 特殊映射
const adRoutesComponentMap = { L: "A", M: "F" };

const adRoutes = createAdRoutes([
  {
    prefix: "TT", // 抖音
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  },
  {
    prefix: "FB", // 脸书
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  },
  {
    prefix: "GG", // 谷歌
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  },
]);

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // 入口页面
    {
      path: "/",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title: "《三國屍心瘋》官方網站-萬屍俱備，只欠發瘋！",
        description:
          "超ㄎㄧㄤ無厘頭殭屍三國放置手遊-《三國屍心瘋》下載即送3000抽和港澳台限定時裝-紅衣小女孩！三國武將全員屍化搞怪來襲！化身道士招募殭屍武將，躺平FUN屍爽！",
        keywords:
          "三國屍心瘋,失心瘋,三國,殭屍,名將,英魂,喪屍,殭王,魔神,重生,末世,歷史,道士,招魂, 盜墓, 醜萌, 搞怪, 策略, 搭配, 佈陣, 卡牌, 抽卡, 佛系, 摸魚, 休閒, 收菜, 放置, 掛機, 無需操作, 豎版, kuso, ㄎㄧㄤ, 無厘頭,  惡搞, 戰鬥，卡牌，多英雄，聯盟,  軍團，開箱，福利，免費遊戲，養成，戰力，社交，動漫，逆襲，進化，放置掛機，升級, 爽快割草, 無限開寶箱，無限開神燈，輕鬆休閒，不肝不課，無門檻福利遊戲,玩具，神器, PS5, Switch, Airpods, iPad Air, iPhone 16 pro, mycard, 免費送, 下載就送, 下載好禮, 下載豪禮, 3000抽,三國屍心瘋官網, 官網 , 免費玩,放置遊戲, 超休閒遊戲, 卡牌養成遊戲，搞怪遊戲，RPG，卡牌RPG手遊，放置卡牌RPG，放置冒險RPG, 殭屍RPG，角色扮演, 不休小隊, 小妖問道，Monster Hunter Now，庫洛魔法使：回憶鑰匙合合合英雄，射射英雄，菇勇者傳說，三國志幻想大陸，眾神派對，馬賽克英雄，噠噠特工，道士出觀，劍與遠征，噠噠騎士團，魔鏡物語，楓之谷, 英雄你好狗, 出發吧麥芬, 轟天騎士團, 潘朵拉, 甘道夫醒醒啦, 土豆兄弟, 暴走小蝦米, 吸血鬼幸存者, 神魔三國志，鹹魚之王，一念逍遙，香腸三國，少年猛將傳，放置七騎士，熱血大作戰、少年神獸傳、太鼓三國志、最後的道長、鬼武三國",
      },
    },
    {
      path: "/m",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title: "《三國屍心瘋》官方網站-萬屍俱備，只欠發瘋！",
        description:
          "超ㄎㄧㄤ無厘頭殭屍三國放置手遊-《三國屍心瘋》下載即送3000抽和港澳台限定時裝-紅衣小女孩！三國武將全員屍化搞怪來襲！化身道士招募殭屍武將，躺平FUN屍爽！",
        keywords:
          "三國屍心瘋,失心瘋,三國,殭屍,名將,英魂,喪屍,殭王,魔神,重生,末世,歷史,道士,招魂, 盜墓, 醜萌, 搞怪, 策略, 搭配, 佈陣, 卡牌, 抽卡, 佛系, 摸魚, 休閒, 收菜, 放置, 掛機, 無需操作, 豎版, kuso, ㄎㄧㄤ, 無厘頭,  惡搞, 戰鬥，卡牌，多英雄，聯盟,  軍團，開箱，福利，免費遊戲，養成，戰力，社交，動漫，逆襲，進化，放置掛機，升級, 爽快割草, 無限開寶箱，無限開神燈，輕鬆休閒，不肝不課，無門檻福利遊戲,玩具，神器, PS5, Switch, Airpods, iPad Air, iPhone 16 pro, mycard, 免費送, 下載就送, 下載好禮, 下載豪禮, 3000抽,三國屍心瘋官網, 官網 , 免費玩,放置遊戲, 超休閒遊戲, 卡牌養成遊戲，搞怪遊戲，RPG，卡牌RPG手遊，放置卡牌RPG，放置冒險RPG, 殭屍RPG，角色扮演, 不休小隊, 小妖問道，Monster Hunter Now，庫洛魔法使：回憶鑰匙合合合英雄，射射英雄，菇勇者傳說，三國志幻想大陸，眾神派對，馬賽克英雄，噠噠特工，道士出觀，劍與遠征，噠噠騎士團，魔鏡物語，楓之谷, 英雄你好狗, 出發吧麥芬, 轟天騎士團, 潘朵拉, 甘道夫醒醒啦, 土豆兄弟, 暴走小蝦米, 吸血鬼幸存者, 神魔三國志，鹹魚之王，一念逍遙，香腸三國，少年猛將傳，放置七騎士，熱血大作戰、少年神獸傳、太鼓三國志、最後的道長、鬼武三國",
      },
    },
    // 预约页
    {
      path: "/pre",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "三國屍心瘋-送3000連抽",
        keywords: "三國，殭屍，紅衣小女孩，3000抽，卡牌，RPG，自動升級，道士",
        description:
          "《三國屍心瘋》是一款超ㄎㄧㄤ無厘頭的殭屍三國題材放置手遊。亂世之下，豪強橫行軍閥混戰，戰火肆虐，以致十室九空，屍橫遍野，積聚了無窮冤煞之氣。有人利用這股煞氣召回當年倒在戰場上的士兵，想要統領殭屍軍團稱霸九州！殭屍四起，末世已臨，玩家將扮演一名以除魔衛道為理想的道長，在意外獲得了駕馭殭屍的方法之後，帶領三國名將對抗邪惡的殭屍軍團，守衛九州大地的安寧！",
      },
    },
    {
      path: "/pre/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "三國屍心瘋-送3000連抽",
        keywords: "三國，殭屍，紅衣小女孩，3000抽，卡牌，RPG，自動升級，道士",
        description:
          "《三國屍心瘋》是一款超ㄎㄧㄤ無厘頭的殭屍三國題材放置手遊。亂世之下，豪強橫行軍閥混戰，戰火肆虐，以致十室九空，屍橫遍野，積聚了無窮冤煞之氣。有人利用這股煞氣召回當年倒在戰場上的士兵，想要統領殭屍軍團稱霸九州！殭屍四起，末世已臨，玩家將扮演一名以除魔衛道為理想的道長，在意外獲得了駕馭殭屍的方法之後，帶領三國名將對抗邪惡的殭屍軍團，守衛九州大地的安寧！",
      },
    },
    // 广告投放营销预约页FB-X渠道
    {
      path: "/pre/FB",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "三國屍心瘋-送3000連抽",
        keywords: "三國，殭屍，紅衣小女孩，3000抽，卡牌，RPG，自動升級，道士",
        description:
          "《三國屍心瘋》是一款超ㄎㄧㄤ無厘頭的殭屍三國題材放置手遊。亂世之下，豪強橫行軍閥混戰，戰火肆虐，以致十室九空，屍橫遍野，積聚了無窮冤煞之氣。有人利用這股煞氣召回當年倒在戰場上的士兵，想要統領殭屍軍團稱霸九州！殭屍四起，末世已臨，玩家將扮演一名以除魔衛道為理想的道長，在意外獲得了駕馭殭屍的方法之後，帶領三國名將對抗邪惡的殭屍軍團，守衛九州大地的安寧！",
      },
    },
    {
      path: "/pre/FB/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "三國屍心瘋-送3000連抽",
        keywords: "三國，殭屍，紅衣小女孩，3000抽，卡牌，RPG，自動升級，道士",
        description:
          "《三國屍心瘋》是一款超ㄎㄧㄤ無厘頭的殭屍三國題材放置手遊。亂世之下，豪強橫行軍閥混戰，戰火肆虐，以致十室九空，屍橫遍野，積聚了無窮冤煞之氣。有人利用這股煞氣召回當年倒在戰場上的士兵，想要統領殭屍軍團稱霸九州！殭屍四起，末世已臨，玩家將扮演一名以除魔衛道為理想的道長，在意外獲得了駕馭殭屍的方法之後，帶領三國名將對抗邪惡的殭屍軍團，守衛九州大地的安寧！",
      },
    },
    // 广告投放营销预约页GG-Y渠道
    {
      path: "/pre/GG",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "三國屍心瘋-送3000連抽",
        keywords: "三國，殭屍，紅衣小女孩，3000抽，卡牌，RPG，自動升級，道士",
        description:
          "《三國屍心瘋》是一款超ㄎㄧㄤ無厘頭的殭屍三國題材放置手遊。亂世之下，豪強橫行軍閥混戰，戰火肆虐，以致十室九空，屍橫遍野，積聚了無窮冤煞之氣。有人利用這股煞氣召回當年倒在戰場上的士兵，想要統領殭屍軍團稱霸九州！殭屍四起，末世已臨，玩家將扮演一名以除魔衛道為理想的道長，在意外獲得了駕馭殭屍的方法之後，帶領三國名將對抗邪惡的殭屍軍團，守衛九州大地的安寧！",
      },
    },
    {
      path: "/pre/GG/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "三國屍心瘋-送3000連抽",
        keywords: "三國，殭屍，紅衣小女孩，3000抽，卡牌，RPG，自動升級，道士",
        description:
          "《三國屍心瘋》是一款超ㄎㄧㄤ無厘頭的殭屍三國題材放置手遊。亂世之下，豪強橫行軍閥混戰，戰火肆虐，以致十室九空，屍橫遍野，積聚了無窮冤煞之氣。有人利用這股煞氣召回當年倒在戰場上的士兵，想要統領殭屍軍團稱霸九州！殭屍四起，末世已臨，玩家將扮演一名以除魔衛道為理想的道長，在意外獲得了駕馭殭屍的方法之後，帶領三國名將對抗邪惡的殭屍軍團，守衛九州大地的安寧！",
      },
    },
    // 广告投放营销预约页TT-Z渠道
    {
      path: "/pre/TT",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "三國屍心瘋-送3000連抽",
        keywords: "三國，殭屍，紅衣小女孩，3000抽，卡牌，RPG，自動升級，道士",
        description:
          "《三國屍心瘋》是一款超ㄎㄧㄤ無厘頭的殭屍三國題材放置手遊。亂世之下，豪強橫行軍閥混戰，戰火肆虐，以致十室九空，屍橫遍野，積聚了無窮冤煞之氣。有人利用這股煞氣召回當年倒在戰場上的士兵，想要統領殭屍軍團稱霸九州！殭屍四起，末世已臨，玩家將扮演一名以除魔衛道為理想的道長，在意外獲得了駕馭殭屍的方法之後，帶領三國名將對抗邪惡的殭屍軍團，守衛九州大地的安寧！",
      },
    },
    {
      path: "/pre/TT/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "三國屍心瘋-送3000連抽",
        keywords: "三國，殭屍，紅衣小女孩，3000抽，卡牌，RPG，自動升級，道士",
        description:
          "《三國屍心瘋》是一款超ㄎㄧㄤ無厘頭的殭屍三國題材放置手遊。亂世之下，豪強橫行軍閥混戰，戰火肆虐，以致十室九空，屍橫遍野，積聚了無窮冤煞之氣。有人利用這股煞氣召回當年倒在戰場上的士兵，想要統領殭屍軍團稱霸九州！殭屍四起，末世已臨，玩家將扮演一名以除魔衛道為理想的道長，在意外獲得了駕馭殭屍的方法之後，帶領三國名將對抗邪惡的殭屍軍團，守衛九州大地的安寧！",
      },
    },
    // 官网首页
    {
      path: "/home",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title: "《三國屍心瘋》官方網站-萬屍俱備，只欠發瘋！",
        description:
          "超ㄎㄧㄤ無厘頭殭屍三國放置手遊-《三國屍心瘋》下載即送3000抽和港澳台限定時裝-紅衣小女孩！三國武將全員屍化搞怪來襲！化身道士招募殭屍武將，躺平FUN屍爽！",
        keywords:
          "三國屍心瘋,失心瘋,三國,殭屍,名將,英魂,喪屍,殭王,魔神,重生,末世,歷史,道士,招魂, 盜墓, 醜萌, 搞怪, 策略, 搭配, 佈陣, 卡牌, 抽卡, 佛系, 摸魚, 休閒, 收菜, 放置, 掛機, 無需操作, 豎版, kuso, ㄎㄧㄤ, 無厘頭,  惡搞, 戰鬥，卡牌，多英雄，聯盟,  軍團，開箱，福利，免費遊戲，養成，戰力，社交，動漫，逆襲，進化，放置掛機，升級, 爽快割草, 無限開寶箱，無限開神燈，輕鬆休閒，不肝不課，無門檻福利遊戲,玩具，神器, PS5, Switch, Airpods, iPad Air, iPhone 16 pro, mycard, 免費送, 下載就送, 下載好禮, 下載豪禮, 3000抽,三國屍心瘋官網, 官網 , 免費玩,放置遊戲, 超休閒遊戲, 卡牌養成遊戲，搞怪遊戲，RPG，卡牌RPG手遊，放置卡牌RPG，放置冒險RPG, 殭屍RPG，角色扮演, 不休小隊, 小妖問道，Monster Hunter Now，庫洛魔法使：回憶鑰匙合合合英雄，射射英雄，菇勇者傳說，三國志幻想大陸，眾神派對，馬賽克英雄，噠噠特工，道士出觀，劍與遠征，噠噠騎士團，魔鏡物語，楓之谷, 英雄你好狗, 出發吧麥芬, 轟天騎士團, 潘朵拉, 甘道夫醒醒啦, 土豆兄弟, 暴走小蝦米, 吸血鬼幸存者, 神魔三國志，鹹魚之王，一念逍遙，香腸三國，少年猛將傳，放置七騎士，熱血大作戰、少年神獸傳、太鼓三國志、最後的道長、鬼武三國",
      },
    },
    {
      path: "/home/m",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title: "《三國屍心瘋》官方網站-萬屍俱備，只欠發瘋！",
        description:
          "超ㄎㄧㄤ無厘頭殭屍三國放置手遊-《三國屍心瘋》下載即送3000抽和港澳台限定時裝-紅衣小女孩！三國武將全員屍化搞怪來襲！化身道士招募殭屍武將，躺平FUN屍爽！",
        keywords:
          "三國屍心瘋,失心瘋,三國,殭屍,名將,英魂,喪屍,殭王,魔神,重生,末世,歷史,道士,招魂, 盜墓, 醜萌, 搞怪, 策略, 搭配, 佈陣, 卡牌, 抽卡, 佛系, 摸魚, 休閒, 收菜, 放置, 掛機, 無需操作, 豎版, kuso, ㄎㄧㄤ, 無厘頭,  惡搞, 戰鬥，卡牌，多英雄，聯盟,  軍團，開箱，福利，免費遊戲，養成，戰力，社交，動漫，逆襲，進化，放置掛機，升級, 爽快割草, 無限開寶箱，無限開神燈，輕鬆休閒，不肝不課，無門檻福利遊戲,玩具，神器, PS5, Switch, Airpods, iPad Air, iPhone 16 pro, mycard, 免費送, 下載就送, 下載好禮, 下載豪禮, 3000抽,三國屍心瘋官網, 官網 , 免費玩,放置遊戲, 超休閒遊戲, 卡牌養成遊戲，搞怪遊戲，RPG，卡牌RPG手遊，放置卡牌RPG，放置冒險RPG, 殭屍RPG，角色扮演, 不休小隊, 小妖問道，Monster Hunter Now，庫洛魔法使：回憶鑰匙合合合英雄，射射英雄，菇勇者傳說，三國志幻想大陸，眾神派對，馬賽克英雄，噠噠特工，道士出觀，劍與遠征，噠噠騎士團，魔鏡物語，楓之谷, 英雄你好狗, 出發吧麥芬, 轟天騎士團, 潘朵拉, 甘道夫醒醒啦, 土豆兄弟, 暴走小蝦米, 吸血鬼幸存者, 神魔三國志，鹹魚之王，一念逍遙，香腸三國，少年猛將傳，放置七騎士，熱血大作戰、少年神獸傳、太鼓三國志、最後的道長、鬼武三國",
      },
    },
    // 下载
    {
      path: "/down",
      meta: {
        title: "三國屍心瘋-送3000連抽事前登錄進行中！",
        keywords:
          "三國戰地無疆,戰地無疆,預約,百萬獎金賽,預創盟,聯盟,同盟,無損換將,村莊經營,廣東話配音,三國戰地無疆攻略,事前登錄,三國, SLG,RPG,ROK,SLG手遊,策略謀略,模擬歷史,手機遊戲,三國謀略,三國策略,攻城,正統,正宗,自由,真實,免費遊戲,即時戰略,巴哈姆特,關羽,趙雲,諸葛亮,孔明,司馬懿,周瑜,曹操,劉備,貂蟬,呂布,孫尚香,武將養成,赤壁,三國演義,歷史小說,三國群英, RTS, 3D,卡牌,抽卡,手遊,神魔,軍師,魔關羽,劍與遠征,王國紀元,部落衝突,文明與征服,萬隆覺醒,三國群英傳戰略版,霸王之業,率土之濱,鴻圖之下,三國志,萬國覺醒,COK,三國志戰略版,三國殺,寒霜啟示錄,新信長之野望,真實三國,策略遊戲,戰爭遊戲,國戰,賽季,Last War,戰火勳章,口袋奇兵,王國之歌",
        description:
          "最真實三國SLG减壓大作-《三國：戰地無疆》事前登錄即送橙將開荒和最高1190抽！首創村莊減負玩法輕鬆發育，告別翻地，無損換將自動徵兵，真正時間花在戰略上！",
      },
      children: adRoutes,
    },
    // 404
    {
      path: "/:pathMatch(.*)*",
      component: () => import("../../components/404.vue"),
    },
    // 测试
    {
      path: "/test",
      component: () => import("./views/test.vue"),
    },
  ],
});
router.beforeEach((to, from, next) => {
  // 路由发生变化改变 description 和 keyword
  ReviseMeta(to.meta.title, to.meta.keywords, to.meta.description);

  // 定义特殊页面白名单，使用正则表达式匹配通配符
  const specialPages = [/^\/down(\/.*)?$/];

  // 检查当前路径是否在特殊页面白名单中
  const isSpecialPage = specialPages.some((pattern) => pattern.test(to.path));

  // 如果是特殊页面，直接调用 next()
  if (isSpecialPage) {
    next();
    return;
  }

  const isWap = deviceType() == "wap";

  // 定义PC端和移动端路径
  let pcPath = to.path.replace(/\/m$/, "");
  let wapPath = pcPath.endsWith("/") ? `${pcPath}m` : `${pcPath}/m`;

  // 根据设备类型跳转，避免重复添加或删除斜杠
  if (isWap && !to.path.endsWith("/m")) {
    next({ path: wapPath, query: to.query });
  } else if (!isWap && to.path.endsWith("/m")) {
    next({ path: pcPath, query: to.query });
  } else {
    next();
  }
});

export default router;
